import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  Collapse,
  useTheme,
  Stack,
  Typography,
  Tooltip,
  Drawer,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../theme";
import { CONSTANT } from "../../utils/Constant";
import {
  HomeIcon,
  UserIcon,
  DepartmentIcon,
  ClientIcon,
  UserLeadsIcon,
  TemplateIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  NotificationsActiveIcon,
  SettingsIcon,
  ForumIcon,
} from "../../components/svgicons/SvgIcons";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import EmailIcon from "@mui/icons-material/Email";
import CampaignIcon from "@mui/icons-material/Campaign";
import StoreIcon from "@mui/icons-material/Store";
import { useSidebarData } from "./SidebarDataContext";

const SidebarMenu = ({ rol, alertClient, alertLead, alertEmail }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [openMenu, setOpenMenu] = useState({});
  const location = useLocation(); // Hook para obtener la ruta actual

  const { isCollapsed, setIsCollapsed, toggled, setToggled, broken } =
    useSidebarData();

  const handleToggle = (menu) => {
    setOpenMenu((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (location.pathname.indexOf("/dashboard/setting") >= 0)
        handleToggle("setting");
      if (location.pathname.indexOf("/dashboard/reportes") >= 0)
        handleToggle("reportes");
    }, 200);

    return () => clearTimeout(timeout);
  }, []);

  const getActiveStyle = (path) => {
    return {
      width: "235px",
      height: "46px",
      mb: "10px",
      backgroundColor:
        location.pathname === path ? colors.primary[500] : colors.primary[450],
      color:
        location.pathname === path ? colors.primary[450] : colors.primary[350],
      boxShadow:
        location.pathname === path ? "0px 4px 4px rgba(0, 0, 0, 0.25)" : "none",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor:
          location.pathname === path
            ? colors.primary[500]
            : colors.primary[450],
        color:
          location.pathname === path
            ? colors.primary[450]
            : colors.primary[350],
      },
    };
  };

  const getActiveStyleIcon = (path) => {
    return location.pathname === path
      ? { width: 25, color: colors.primary[450], fontWeight: "bold" } // Estilos para la ruta activa
      : { width: 25, fontWeight: "bold", color: colors.primary[500] };
  };

  const getActiveStyleIconNotification = (path) => {
    return location.pathname === path
      ? { fontSize: "0.9rem", width: 16, color: colors.primary[450] } // Estilos para la ruta activa
      : { fontSize: "0.9rem", width: 16, color: colors.primary[500] };
  };

  return (
    <Box /* sx={{ width: 250 }} */>
      <List>
        <ListItemButton
          component={Link}
          to="/dashboard/home"
          sx={getActiveStyle("/dashboard/home")}
          onClick={() => broken && setToggled(!toggled)}
        >
          <ListItemIcon>
            <HomeIcon style={getActiveStyleIcon("/dashboard/home")} />
          </ListItemIcon>
          <Stack direction="row" gap={3}>
            <Typography
              variant="h5"
              fontWeight="bold"
              color={
                location.pathname === "/dashboard/home"
                  ? colors.primary[450]
                  : colors.primary[500]
              }
            >
              {CONSTANT.LABEL_DASHBOARD}
            </Typography>
          </Stack>
        </ListItemButton>

        {rol === 1 && (
          <ListItemButton
            component={Link}
            to="/dashboard/googleads"
            sx={getActiveStyle("/dashboard/googleads")}
            onClick={() => broken && setToggled(!toggled)}
          >
            <ListItemIcon>
              <BarChartIcon style={getActiveStyleIcon("/dashboard/googleads")} />
            </ListItemIcon>
            <Stack direction="row" gap={3}>
              <Typography
                variant="h5"
                fontWeight="bold"
                color={
                  location.pathname === "/dashboard/googleads"
                    ? colors.primary[450]
                    : colors.primary[500]
                }
              >
                Google Ads
              </Typography>
            </Stack>
          </ListItemButton>
        )}

        <ListItemButton
          component={Link}
          to="/dashboard/clientsleadsnuevo"
          onClick={() => broken && setToggled(!toggled)}
          sx={getActiveStyle("/dashboard/clientsleadsnuevo")}
        >
          <ListItemIcon>
            <UserLeadsIcon
              style={getActiveStyleIcon("/dashboard/clientsleadsnuevo")}
            />
          </ListItemIcon>
          <Stack direction="row" gap={3}>
            <Typography
              variant="h5"
              fontWeight="bold"
              color={
                location.pathname === "/dashboard/clientsleadsnuevo"
                  ? colors.primary[450]
                  : colors.primary[500]
              }
            >
              {CONSTANT.LABEL_CLIENTS_LEADS}
            </Typography>
            {alertLead && (
              <Tooltip title={CONSTANT.LABEL_NEW_MESSAGE}>
                <div>
                  <NotificationsActiveIcon
                    style={getActiveStyleIconNotification(
                      "/dashboard/clientsleadsnuevo"
                    )}
                  />
                </div>
              </Tooltip>
            )}
            {alertEmail && (
              <Tooltip title="Correos nuevos">
                <div>
                  <EmailIcon
                    style={{
                      ...getActiveStyleIconNotification("/dashboard/clientsleadsnuevo"),
                      color: location.pathname === "/dashboard/clientsleadsnuevo"
                        ? colors.primary[450]
                        : "#1565c0",
                    }}
                  />
                </div>
              </Tooltip>
            )}
          </Stack>
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/dashboard/clients"
          sx={getActiveStyle("/dashboard/clients")}
          onClick={() => broken && setToggled(!toggled)}
        >
          <ListItemIcon>
            <ClientIcon style={getActiveStyleIcon("/dashboard/clients")} />
          </ListItemIcon>
          <Stack direction="row" gap={3}>
            <Typography
              variant="h5"
              fontWeight="bold"
              color={
                location.pathname === "/dashboard/clients"
                  ? colors.primary[450]
                  : colors.primary[500]
              }
            >
              {CONSTANT.LABEL_CLIENTS}
            </Typography>
            {alertClient && (
              <Tooltip title={CONSTANT.LABEL_NEW_MESSAGE}>
                <div>
                  <NotificationsActiveIcon
                    style={getActiveStyleIconNotification("/dashboard/clients")}
                  />
                </div>
              </Tooltip>
            )}
          </Stack>
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/dashboard/vendors"
          sx={getActiveStyle("/dashboard/vendors")}
          onClick={() => broken && setToggled(!toggled)}
        >
          <ListItemIcon>
            <StoreIcon style={getActiveStyleIcon("/dashboard/vendors")} />
          </ListItemIcon>
          <Stack direction="row" gap={3}>
            <Typography
              variant="h5"
              fontWeight="bold"
              color={
                location.pathname === "/dashboard/vendors"
                  ? colors.primary[450]
                  : colors.primary[500]
              }
            >
              Proveedores
            </Typography>
          </Stack>
        </ListItemButton>

        {rol === 1 && (
          <ListItemButton
            component={Link}
            to="/dashboard/marketing"
            sx={getActiveStyle("/dashboard/marketing")}
            onClick={() => broken && setToggled(!toggled)}
          >
            <ListItemIcon>
              <CampaignIcon style={getActiveStyleIcon("/dashboard/marketing")} />
            </ListItemIcon>
            <Stack direction="row" gap={3}>
              <Typography
                variant="h5"
                fontWeight="bold"
                color={
                  location.pathname === "/dashboard/marketing"
                    ? colors.primary[450]
                    : colors.primary[500]
                }
              >
                Marketing
              </Typography>
            </Stack>
          </ListItemButton>
        )}

        {rol === 1 && (
          <ListItemButton
            component={Link}
            to="/dashboard/proposals"
            sx={getActiveStyle("/dashboard/proposals")}
            onClick={() => broken && setToggled(!toggled)}
          >
            <ListItemIcon>
              <DescriptionIcon style={getActiveStyleIcon("/dashboard/proposals")} />
            </ListItemIcon>
            <Stack direction="row" gap={3}>
              <Typography
                variant="h5"
                fontWeight="bold"
                color={
                  location.pathname === "/dashboard/proposals"
                    ? colors.primary[450]
                    : colors.primary[500]
                }
              >
                Propuestas
              </Typography>
            </Stack>
          </ListItemButton>
        )}

        {rol === 1 && (
          <>
            <ListItemButton
              onClick={() => handleToggle("reportes")}
              sx={getActiveStyle("__reportes_parent__")}
            >
              <ListItemIcon>
                <AssessmentIcon
                  style={{ width: 25, fontWeight: "bold", color: colors.primary[500] }}
                />
              </ListItemIcon>
              <Stack direction="row" gap={3}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  color={colors.primary[500]}
                >
                  {CONSTANT.LABEL_REPORTS}
                </Typography>
              </Stack>
              {openMenu.reportes ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemButton>
            <Collapse in={openMenu.reportes} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  component={Link}
                  to="/dashboard/reportes/semanal"
                  sx={{
                    ...getActiveStyle("/dashboard/reportes/semanal"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <DateRangeIcon
                      style={getActiveStyleIcon("/dashboard/reportes/semanal")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/reportes/semanal"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_WEEKLY}
                    </Typography>
                  </Stack>
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/dashboard/reportes/mensual"
                  sx={{
                    ...getActiveStyle("/dashboard/reportes/mensual"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <CalendarMonthIcon
                      style={getActiveStyleIcon("/dashboard/reportes/mensual")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/reportes/mensual"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_MONTHLY}
                    </Typography>
                  </Stack>
                </ListItemButton>
                              <ListItemButton
                  component={Link}
                  to="/dashboard/reportes/funnel"
                  sx={{
                    ...getActiveStyle("/dashboard/reportes/funnel"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <FilterAltIcon
                      style={getActiveStyleIcon("/dashboard/reportes/funnel")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/reportes/funnel"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      Funnel
                    </Typography>
                  </Stack>
                </ListItemButton>
</List>
            </Collapse>
          </>
        )}

        {rol === 1 && (
          <>
            <ListItemButton
              to="/dashboard/setting"
              /* onClick={() => {
                handleToggle("setting");
              }} */
              sx={getActiveStyle("/dashboard/setting")}
            >
              <ListItemIcon>
                <SettingsIcon
                  style={getActiveStyleIcon("/dashboard/setting")}
                />
              </ListItemIcon>
              <Stack direction="row" gap={3}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  color={
                    location.pathname === "/dashboard/setting"
                      ? colors.primary[450]
                      : colors.primary[500]
                  }
                >
                  {CONSTANT.LABEL_SETTING}
                </Typography>
              </Stack>
              {/* {openMenu.setting ? <ExpandLessIcon /> : <ExpandMoreIcon />} */}
            </ListItemButton>
            {/* <Collapse in={openMenu.setting} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  component={Link}
                  to="/dashboard/setting/users"
                  sx={{
                    ...getActiveStyle("/dashboard/setting/users"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <UserIcon
                      style={getActiveStyleIcon("/dashboard/setting/users")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/setting/users"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_USERS}
                    </Typography>
                  </Stack>
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/dashboard/setting/companies"
                  sx={{
                    ...getActiveStyle("/dashboard/setting/companies"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <DepartmentIcon
                      style={getActiveStyleIcon("/dashboard/setting/companies")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/setting/companies"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_COMPANIES}
                    </Typography>
                  </Stack>
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/dashboard/setting/template/whatsapp/twilio"
                  sx={{
                    ...getActiveStyle(
                      "/dashboard/setting/template/whatsapp/twilio"
                    ),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <TemplateIcon
                      style={getActiveStyleIcon(
                        "/dashboard/setting/template/whatsapp/twilio"
                      )}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname ===
                        "/dashboard/setting/template/whatsapp/twilio"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_TEMPLATE_TWILIO}
                    </Typography>
                  </Stack>
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/dashboard/setting/template/whatsapp/quickresponse"
                  sx={{
                    ...getActiveStyle(
                      "/dashboard/setting/template/whatsapp/quickresponse"
                    ),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <TemplateIcon
                      style={getActiveStyleIcon(
                        "/dashboard/setting/template/whatsapp/quickresponse"
                      )}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname ===
                        "/dashboard/setting/template/whatsapp/quickresponse"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_TEMPLATE_QUICK_RESPONSE}
                    </Typography>
                  </Stack>
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/dashboard/setting/autoreply"
                  sx={{
                    ...getActiveStyle("/dashboard/setting/autoreply"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <TemplateIcon
                      style={getActiveStyleIcon("/dashboard/setting/autoreply")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/setting/autoreply"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_TEMPLATE_AUTO_REPLY}
                    </Typography>
                  </Stack>
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/dashboard/setting/massive"
                  sx={{
                    ...getActiveStyle("/dashboard/setting/massive"),
                    pl: 4,
                  }}
                  onClick={() => broken && setToggled(!toggled)}
                >
                  <ListItemIcon>
                    <ForumIcon
                      style={getActiveStyleIcon("/dashboard/setting/massive")}
                    />
                  </ListItemIcon>
                  <Stack direction="row" gap={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={
                        location.pathname === "/dashboard/setting/massive"
                          ? colors.primary[450]
                          : colors.primary[500]
                      }
                    >
                      {CONSTANT.LABEL_MASSIVE}
                    </Typography>
                  </Stack>
                </ListItemButton>
              </List>
            </Collapse> */}
          </>
        )}

      </List>
    </Box>
  );
};

export default SidebarMenu;
